import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const files = require.context("", false, /^\.\/.*\.router.js$/);
const routes = files
  .keys()
  .reduce((acc, curr) => acc.concat(files(curr).default), []);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.getters["auth/isAuthenticated"];
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (isAuthenticated) {
      return next();
    }
    return router.push("/#login");
  }
  if (to.matched.some((record) => !record.meta.requiresAuth)) {
    if (isAuthenticated) {
      if (to.path === "/verify-email") return next();
      return router.push("/designer");
    }
  }
  next();
});

export default router;
